import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useCallback } from 'react';
import SearchBar from './SearchBar.js';
import ActionButtons from './ActionButtons.js';
import ContentSwitchButtons from './ContentSwitchButtons.js';

const Root = styled(MuiBox, { shouldForwardProp: prop => prop !== 'rtl' }) `
  ${({ height, rtl, theme }) => `
    width: 100%; 
    height: ${height || theme.spacing(7.5)}; 
    margin-bottom: ${theme.spacing(3)}; 
    display: flex;
    flex-direction: ${rtl ? 'row-reverse' : 'row'};
  `}
`;
const _SearchBar = styled(SearchBar) `
  height: 28px;
  margin-top: 1px;
`;
const TopBar = (_a) => {
    var { globalFilter, setGlobalFilter, rtl, disabled, topBarOptions, searchInputProps } = _a, rest = __rest(_a, ["globalFilter", "setGlobalFilter", "rtl", "disabled", "topBarOptions", "searchInputProps"]);
    const { onContentSwitchSelectionChange } = topBarOptions || {};
    const onContentSwitchChange = useCallback((option) => {
        onContentSwitchSelectionChange && onContentSwitchSelectionChange(option);
    }, [onContentSwitchSelectionChange]);
    if (!topBarOptions) {
        return null;
    }
    const { contentSwitchOptions, enableSearchFilter, LeftComponent, RightComponent } = topBarOptions;
    if (!contentSwitchOptions && !enableSearchFilter && !LeftComponent && !RightComponent) {
        return null;
    }
    return (jsxs(Root, Object.assign({ rtl: rtl }, rest, { "data-testid": "grid-topbar" }, { children: [!!contentSwitchOptions && (jsx(ContentSwitchButtons, Object.assign({}, { contentSwitchOptions, rtl }, { "data-testid": "topbar-content-switch", onContentSwitchSelectionChange: onContentSwitchChange }))), !!enableSearchFilter && (jsx(_SearchBar, Object.assign({}, { globalFilter, setGlobalFilter, disabled, rtl, searchInputProps }, { "data-testid": "topbar-search" }))), (!!RightComponent || !!LeftComponent) && (jsx(ActionButtons, Object.assign({ "data-testid": "topbar-action-buttons" }, { rtl, LeftComponent, RightComponent })))] })));
};

export { TopBar as default };
//# sourceMappingURL=TopBar.js.map
